import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { combineLatest } from 'rxjs/observable/combineLatest';
import 'rxjs/add/operator/finally';

import { StorageService } from '../../../core/services';
import { requiredValidator } from '../../validators/index';

interface ImportFile {
  name: string;
  path: string;
  url?: string;
}

interface Pending {
  file: File;
  form: FormGroup;
}

@Component({
  selector: 'app-imports-upload-modal',
  templateUrl: './upload-imports-modal.component.html',
})
export class UploadImportsModalComponent {
  active = false;
  pending: Pending[];
  uploading = false;
  @Input() for = null;
  @Output() onUploaded = new EventEmitter<ImportFile[]>();

  constructor(private storage: StorageService) {}

  open(files: File[]) {
    this.pending = files.map(file => {
      const form = new FormGroup({
        name: new FormControl(file.name, requiredValidator()),
      });
      return { file, form };
    });

    this.active = true;
  }

  close() {
    this.pending = null;
    this.active = false;
  }

  remove(importFile: Pending) {
    this.pending = this.pending.filter(a => a !== importFile);

    if (! this.pending.length) {
      this.close();
    }
  }

  upload() {
    // Ensure forms is valid
    if (! this.valid) {
      return;
    }

    this.uploading = true;

    // Create upload observables
    const uploads = this.pending.map(importFile =>
      this.storage.upload(importFile.file).map(upload => {
        return {
          ...upload,
          name: importFile.form.value.name,
        };
      })
    );

    // Fire observers and collect results
    // Woo, beautiful parallel uploads
    combineLatest(...uploads)
      .finally(() => this.uploading = false)
      .subscribe(uploadedFiles => {
        this.onUploaded.emit(uploadedFiles);
        this.close();
      });
  }

  get valid() {
    return this.pending
        && this.pending.every(uploadedFile => uploadedFile.form.valid);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/imports/upload-imports-modal.component.ts